module.exports = __webpack_public_path__ + "img/xianlu.40262250.png";